import { Box, Divider, Stack, Typography } from '@mui/material';
import { useMemo } from 'react';
import InfoIcon from '@mui/icons-material/Info';
import { Link } from 'react-router-dom';
import { EmptyHeatMapContainer, EmptyHeatMapTypography, EmptyHeatMapIcon } from './styles';

type EmptyHeatMapProps = {
  doesSelectedFiltersHeatMapExist: boolean;
};

export const EmptyHeatMap = ({ doesSelectedFiltersHeatMapExist }: EmptyHeatMapProps) => {
  const displayText = useMemo(() => {
    if (doesSelectedFiltersHeatMapExist) {
      return (
        <Typography variant="subtitle1" textAlign="center" sx={EmptyHeatMapTypography}>
          Heatmap properties for the applied queries are not available.
        </Typography>
      );
    }

    return (
      <Typography variant="subtitle1" textAlign="center" sx={EmptyHeatMapTypography}>
        Heatmap properties are not available, please contact{' '}
        <Link to="mailto:fabric-support@abysssolutions.com.au">support</Link>
      </Typography>
    );
  }, [doesSelectedFiltersHeatMapExist]);

  return (
    <>
      <Divider />
      <Box sx={EmptyHeatMapContainer}>
        <Stack
          sx={{
            alignItems: 'center',
          }}
        >
          <InfoIcon sx={EmptyHeatMapIcon} />
          {displayText}
        </Stack>
      </Box>
    </>
  );
};
